import React from 'react';

const PickupCancellationFeeBadge = ({canceledWithFee, className = ''}) => {
    if (canceledWithFee !== true) return null;

    return (
        <span className={`badge badge-warning ${className}`.trim()}>
            Canceled with fee
        </span>
    );
};

export default PickupCancellationFeeBadge;
